// import getLocationPathname from './get-location-pathname';

import getApiUrlParts from './get-api-url-parts';

/**
 * @memberof ux-tread-dotcom-utils
 * getApiPathFromUrl takes a full url and returns the relevant api path of domain/resource/version per Nike's API standards or the full url
 * @param {string} url - full url used in an api call
 * @example <caption>Usage of getApiPathFromUrl</caption>
 * import { getApiPathFromUrl } from '@nike/ux-tread-dotcom-utils';
 * const apiPath = getApiPathFromUrl('https://api.nike.com/buy/carts/v1/some-id')
 *
 * console.log(apiPath);
 * // apiPath -> 'buy/carts/v1'
 * @returns {string} the api path containing {domain}/{resource}/{version}
 */
export default function getApiPathFromUrl(url) {
  var _getApiUrlParts = getApiUrlParts(url),
    domain = _getApiUrlParts.domain,
    resource = _getApiUrlParts.resource,
    version = _getApiUrlParts.version;
  return domain && resource && version ? "".concat(domain, "/").concat(resource, "/").concat(version) : url;
  // an alternate way to achieve this is to just use regex and replace which will still return full url as fallback
  // return url.replace(/^.*.com\/(.*v\d+)[/?].*$/, '$1');
}

/*
  regex method
  82b -> 109b
  vs
  module usage
  172 -> 330b + 2.2kb = 2.5kb (see comparison.test.js)
*/